import { render } from "./UserProjectsList.vue?vue&type=template&id=f7eab2d4"
import script from "./UserProjectsList.vue?vue&type=script&lang=js"
export * from "./UserProjectsList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__